module.exports = __webpack_public_path__ + "static/hiw_walker-9a5e263d48ff839e0300f688597d5030.svg";